var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.818,
    height: 9.455,
    viewBox: "0 0 11.818 9.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.215,10.721l-4.342-3.9A.226.226,0,0,0,11.7,6.75c-.135.006-.308.1-.308.236V8.942a.128.128,0,0,1-.111.121C6.966,9.7,5.147,12.8,4.5,16.022c-.025.127.154.245.237.145a7.951,7.951,0,0,1,6.523-3.173.148.148,0,0,1,.129.142v1.921a.266.266,0,0,0,.446.157l4.372-3.968A.32.32,0,0,0,16.32,11,.387.387,0,0,0,16.215,10.721Z",
    transform: "translate(-4.502 -6.749)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.5e8f90bf309106593e026f76c46bbc24.svg";
export { ForwardRef as ReactComponent };